import { Modal } from "react-bootstrap";
import ReactLoading from "react-loading";


export default function MarkModal(props) {
    return (
        <div>
            <Modal show={props.show} onHide={props.hide} size="lg" centered>
                <Modal.Header className="return-header">
                    <span className="text-warning"> PLEASE CONFIRM </span>
                </Modal.Header>
                <Modal.Body className="return-body text-center">
                    <span>Are you sure you want to {props.type} </span>
                </Modal.Body>
                <Modal.Footer className="return-footer">
                    <div className="col-sm-12 mt-3 d-flex justify-content-end">
                        <button type="button" className={props.type === "disapprove" ? "button-warning" : "button-secondary me-2"} onClick={props.hide}>Cancel</button>
                        {props.isClicked === true && (
                            <div className="button-primary d-flex justify-content-center">
                                <ReactLoading
                                    type="bubbles"
                                    color="#FFFFFF"
                                    height={50}
                                    width={50}
                                />
                            </div>
                        )}
                        {props.isClicked === false && (
                            <button type="button" className={props.type === "disapprove" ? "button-warning-fill" : "button-primary"} onClick={props.handler}>Proceed</button>
                        )}
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    )
}